import React from 'react';
import '../../../../css/common/chat/ChatHeaderControls.css';

const joinClassNames = (...tokens) => tokens.filter(Boolean).join(' ');

const ChatAreaHeader = ({
  className = '',
  mainClassName = '',
  actionsClassName = '',
  disableMainWrapper = false,
  showBackButton = false,
  onBack = null,
  backButtonClassName = '',
  backAriaLabel = '戻る',
  backTitle = '戻る',
  backIconClassName = 'fa-solid fa-chevron-left',
  main = null,
  actions = null,
}) => {
  const mainContent = (
    <>
      {showBackButton ? (
        <button
          type="button"
          className={backButtonClassName}
          onClick={onBack}
          aria-label={backAriaLabel}
          title={backTitle}
        >
          <i className={backIconClassName} aria-hidden="true"></i>
        </button>
      ) : null}
      {main}
    </>
  );

  return (
    <header className={joinClassNames('chat-area-header', className)}>
      {disableMainWrapper ? mainContent : <div className={mainClassName}>{mainContent}</div>}
      {actions ? <div className={actionsClassName}>{actions}</div> : null}
    </header>
  );
};

export default ChatAreaHeader;
